<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <van-nav-bar
        title="缴费记录"
        left-arrow
        :fixed=flexfalg
        @click-left="onClickLeft"
      />
      <div class="top"></div>
      <!-- <Nav :title="'缴费记录'" :fixed="true"></Nav>
      <div class="top"> -->
        
    </div>
    <div v-if="emptyflag">
      <van-empty image="https://account.kmmds.top/datainfo_pic/error.png" description="暂无缴费信息" />
    </div>
     <van-popup v-model="showcode" round :style="{ height: '40%' , width:'70%'}" closeable>
     <div class="popqrcode_box">
       <div class="popqrcode_text">就诊卡号</div>
     <ProductQrcode :qrcode="pid" :width="width" :height="height" class="popqrcode" />
       <div class="popqrcode_text">{{pid}}</div>
     </div>
      </van-popup>
    <div  class="paycard" v-for="(item,index) in payHisInfo" :key="index" v-if="!emptyflag &&item.tradeType==1"  @click="showpop(item)">
      <div class="head">
        <div>发票号：{{item.invoiceNo}}</div>
      </div>
      <div claass="content"> 
        
        <div class="Crow">
        <div>{{name}}</div>
        <div class="green">已缴费</div>
        </div>
        <div class="Crow">
          <div>费用</div>
          <div>￥{{item.amount}}</div>
        </div>
       <div class="Crow">
          <div>付款时间</div>
          <div>{{item.operDate}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import backindex from '@/mixins/backindex'
import ProductQrcode from "@/components/ProductQrcode";
export default {
    mixins: [backindex],
   data() {
    return {
      emptyflag:false,
      flexfalg:true,
      clientId:"",
      name:"",
      payHisInfo:[],
      showcode:false,
      pid:"",
       width: 165,
      height: 165,
    };
  },
  components:{
    Nav,
    ProductQrcode
  },
  mounted(){
     if (this.$route.query) {
       console.log(this.$route.query);
       this.clientId = this.$route.query.clientId;
      this.name = this.$route.query.name
    }
    if (!this.clientId || this.clientId == "") {
      // this.Dialog();
      this.$router.push('/patient_card_confUser_C')
      return;
    }
    this.getpayhistoryinfo()
  },
  methods:{
    showpop(item){
      this.pid=item.medCardNo
      this.showcode=true
    },
    onClickLeft(){
      this.$router.push('/index');
    },
   Dialog() {
      // console.log(123)
      this.$dialog
        .confirm({
          message: "请选择就诊人信息",
        })
        .then(() => {
          this.$router.push('/confUser')
        })
        .catch(() => {
          // on cancel
          this.$router.push("/index");
        });
    },
    //获取列表
    async getpayhistoryinfo(medCardNo) {
       this.$showLoad();
      let url = "/outpatientfee/queryprepayrecord";
      let res_data = {
        medCardNo: this.clientId,
      };
      await this.$axios_request.request_data(
        "nodeserver",
        url,
        "POST",
        res_data,
        (data) => {
          console.log(data.data)
          this.payHisInfo = data.data
            this.payHisInfo.sort(function (a, b) {
                return new Date(b.operDate.replace(/-/g, '/')) - new Date(a.operDate.replace(/-/g, '/'));
              });
          if(data.data.length==0){
            this.emptyflag=true
          }
            this.$hideLoad();
        }
      );
      // this.isLoad = true
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  .top{
  height: 50px;
}
  .paycard {
    padding: 5px;
    width: 90%;
    display: flex;
    flex-direction: column;
    // border: 1px solid #5b8df6;
    border-radius: 15px;
    margin: 0px auto;
    margin-top: 8px;
    margin-bottom: 8px;
    box-shadow: 0 8px 12px #6666;
  }
  .head {
    margin-left: 10px;
    margin-right: 10px;
    color: #5b8df6;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #5b8df6;
    font-size: 16px;
  }
  .content {
    width: 90%;
    
    display: flex;
    flex-direction: column;
    border: 1px solid #95a5a6;
    border-radius: 15px;
    margin: 5px auto;
  }
  .Crow {
    color:#747d8c;
    margin-left: 20px;
    margin-right: 20px;
    line-height: 25px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .gold{
        color: #e74c3c;
    }
    .green{
        color: #2ed573;
    }
  }
  .line {
    border-bottom: 1px solid #95a5a6;
  }
 .popqrcode_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: 100%;
  height: 100%;
  .popqrcode {
    margin-top:2vh;
    margin-bottom: 3vh;
  }
  .popqrcode_text {
    text-align: center;
    font-size: 16px;
  }
}
  
}
</style>